module.exports = {
	"pagination": {
		"GetApiKeys": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetBasePathMappings": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetClientCertificates": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetDeployments": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetDomainNames": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetModels": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetResources": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetRestApis": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetUsage": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetUsagePlans": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		},
		"GetUsagePlanKeys": {
			"input_token": "position",
			"output_token": "position",
			"limit_key": "limit",
			"result_key": "items"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/apigateway-2015-07-09.paginators.json
 ** module id = 1257
 ** module chunks = 0
 **/